import React, {useState } from 'react';
import { Link } from 'react-router-dom';
import './authStyles/Login.css'; // Import external CSS for styling
import { API_ROOT } from '../../supplementary_components/requests';

import { CustomLoadingIcon } from '../../supplementary_components/loading_icon';
function ForgotPassword() {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [carrierId, setCarrierId] = useState(localStorage.getItem('carrier_identifier') || '');
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if(loading){
            return;
        }
        setLoading(true);
        setError(null);
        setMessage(null);

        try {
            const response = await fetch(API_ROOT+'auth/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, carrierIdentifier: carrierId }),
            });

            if (response.ok) {
                setMessage('A temporary password has been sent to your email.');
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Failed to send password reset email.');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error during password reset:', error);
            setError('No such email exists. Please check email address.');
        }
    };

    return (
        <div className="loginFormWrapper">
            <div className="loginFormBox">
                <div className="pageLabel">Forgot Password</div>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="carrierId">MC or DOT Number:</label>
                            <input
                                id="carrierId"
                                value={carrierId}
                                onChange={(e) => setCarrierId(e.target.value)}
                                required
                            />
                    </div>
                    
                    <div className="input-group">
                        
                        <label htmlFor="email">Enter your email:</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="submit-group">
                        <button type="submit" disabled={loading}>Submit</button>
                        {loading?<CustomLoadingIcon height={'1.2rem'} speed={1.0} strokeColor="white" />:null}
                    </div>
                    <div className="forgot-password">
                        <Link to="/login" className="back-to-login">Go back to Login</Link>
                    </div>
                   
                </form>
            </div>
        </div>
    );
}

export default ForgotPassword;
